import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';

import styles from './PlainIcon.module.scss';

const colors: Record<string, string> = {
  positive: 'var(--viz-bullish)',
  negative: 'var(--viz-bearish)',
  neutral: 'var(--icon-default)',
};

const TOOLTIP_TRIGGER_SIZE = 12;

interface DirectionalIconProps {
  mostRecent?: boolean;
  translateX?: number;
  translateY?: number;
  direction: string;
  valueString: string;
  dateString: string;
}

export const PlainIcon = ({
  mostRecent = false,
  translateX = 0,
  translateY = 0,
  direction,
  valueString,
  dateString,
}: DirectionalIconProps) => {
  return (
    <Tooltip
      isTouchDevice={false}
      trigger={TooltipTrigger.Hover}
      label={
        <div className={styles.labelWrapper}>
          <span className={styles.date}>{dateString}</span>
          <span className={styles.value}>{valueString}</span>
        </div>
      }
      inPortal
      aria-label={`${dateString}: ${valueString}`}
    >
      <g
        transform={`translate(${translateX}, ${translateY})`}
        className="plain-icon-group"
      >
        <rect
          width={TOOLTIP_TRIGGER_SIZE}
          height={TOOLTIP_TRIGGER_SIZE}
          fill="none"
          transform={`translate(${-TOOLTIP_TRIGGER_SIZE / 2}, ${
            -TOOLTIP_TRIGGER_SIZE / 2
          })`}
        />
        <g data-testid={`plain-icon-wrapper${mostRecent ? '-last' : ''}`}>
          {!mostRecent ? (
            <circle
              className={styles.circleIcon}
              style={{ fill: colors[direction] }}
            />
          ) : (
            <>
              <circle
                className={styles.circleIcon}
                style={{ fill: colors[direction] }}
              />
              <circle
                className={styles.circleRingIcon}
                style={{ stroke: colors[direction] }}
              />
            </>
          )}
        </g>
      </g>
    </Tooltip>
  );
};
